import React from "react";
import Box, { BoxProps } from "../box/Box";
import Heading, { HeadingProps } from "../typography/Heading";
import SvgBox, { SvgBoxProps } from "../box/SvgBox";

export function Card(props: BoxProps) {
  return <Box border="1px" borderColor="gray.100" borderRadius="sm" {...props} />;
}

export function CardHeader(props: BoxProps) {
  return (
    <Box
      py={3}
      px={4}
      borderBottom="1px"
      bg="white"
      borderColor="gray.100"
      display="flex"
      alignItems="center"
      justifyContent="center"
      {...props}
    />
  );
}

export function CardTitle(props: HeadingProps) {
  return <Heading as="h3" color="blue.600" fontSize="lg" m={0} fontWeight="bold" {...props} />;
}

export function CardIcon({ ...props }: SvgBoxProps) {
  return <SvgBox data-custom-icon={true} focusable="false" aria-hidden="true" color="currentColor" mr={2} {...props} />;
}

export function CardBody(props: BoxProps) {
  return <Box p={4} {...props} bg="white" />;
}
